import styled from 'styled-components';

export const MobileAppLoginStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    
    input::placeholder {
        color: var(--color-secondary);
        opacity: 1;
    }
`;

export const MobileAppForgotPasswordLinkContainerStyled = styled.div`
    display: flex;
    justify-content: end;
    margin-top: 8px;
    
    a {
        color: var(--color-white);
        font-size: 16px;
    }
`;
